import { render, staticRenderFns } from "./ShopGuideDetail.vue?vue&type=template&id=289339f2"
import script from "./ShopGuideDetail.vue?vue&type=script&lang=js"
export * from "./ShopGuideDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports